import { FC } from "react";
import { useTranslation } from "react-i18next";

import { isTranslationKey } from "../localize.helpers";
import { Log } from "../log.helpers";
import { ToastBoxStyled } from "./toast-widgets.styled";

interface IToastInfoBox {
  message: string;
  subMessage?: string;
}

export const ToastInfoBox: FC<IToastInfoBox> = ({ message, subMessage }) => {
  const { t } = useTranslation();
  Log.debug("Toast info box:", message, subMessage);
  const messageTranslated = isTranslationKey(message) ? t(message) : message;

  if (!subMessage) {
    return messageTranslated;
  }

  return (
    <ToastBoxStyled>
      <p className="message">{messageTranslated}</p>
      {!!subMessage && (
        <p className="details">
          {isTranslationKey(subMessage) ? t(subMessage) : subMessage}
        </p>
      )}
    </ToastBoxStyled>
  );
};
